// extracted by mini-css-extract-plugin
module.exports = {"container":"SuperCorrector_container__17XvA","textAreaContainer":"SuperCorrector_textAreaContainer__1RQ_3","buttonsContainer":"SuperCorrector_buttonsContainer__3w2vb"};